<template>
    <SOSlotCard :card-type="'shadow'">
        <template v-slot:card_head>
            <span
                v-if="permintaan.status === 1"
                class="f-regular f-12 f-c-midgrey bg-gray rounded m-d-4"
                style="padding: 2px 4px"
            >
                Menunggu konfirmasi
            </span>
            <div class="d-flex-between-center f-16 f-semi f-c-black m-d-4">
                <div
                    class="m-d-0 f-c-black"
                    v-if="search !== ''"
                    v-html="searchHighlight('Rp ' + formatRupiah(permintaan.total_nominal), search)"
                ></div>
                <div class="m-d-0 f-c-black" v-else>Rp {{ formatRupiah(permintaan.total_nominal) }}</div>
                <img src="@/assets/icons/chevron_right_4.svg" />
            </div>
        </template>
        <template v-slot:card_body>
            <div class="f-regular f-13 f-c-midgrey m-d-2">
                <img src="@/assets/icons/outlet-out-muted.svg" alt="" />
                <span
                    class="f-c-black"
                    v-if="search !== ''"
                    v-html="
                        searchHighlight(
                            permintaan.akun_tujuan !== ''
                                ? permintaan.akun_tujuan + '  •  ' + permintaan.nama_outlet
                                : permintaan.nama_outlet,
                            search
                        )
                    "
                ></span>
                <span v-else class="m-l-4">{{
                    permintaan.akun_tujuan !== ""
                        ? permintaan.akun_tujuan + "  •  " + permintaan.nama_outlet
                        : permintaan.nama_outlet
                }}</span>
            </div>
        </template>
        <template v-slot:card_footer>
            <div class="row m-0 need-confirm f-12 permintaan-outlet-card-footer-bg" v-if="permintaan.status === 1">
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + permintaan.nama_karyawan, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 nomore" v-else>Oleh {{ permintaan.nama_karyawan }}</div>
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(permintaan.created_at_formated, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 text-right" v-else>
                    ({{ permintaan.created_at_formated }})
                </div>
            </div>

            <div class="row m-0 need-confirm f-12 align-items-center" v-else>
                <div
                    class="col-md-4 col-sm-4 col-4 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + permintaan.nama_karyawan, search)"
                ></div>
                <div class="col-md-4 col-sm-4 col-4 p-0 nomore" v-else>Oleh {{ permintaan.nama_karyawan }}</div>
                <div
                    class="col-md-5 col-sm-5 col-5 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(permintaan.created_at_formated, search)"
                ></div>
                <div class="col-md-5 col-sm-5 col-5 p-0 text-right" v-else>
                    ({{ permintaan.created_at_formated }})
                </div>
                <div class="col-md-3 col-sm-3 col-3 p-0 text-right">
                    <span class="badge-tag tg-green" v-if="permintaan.status === 2">Disetujui</span>
                    <span class="badge-tag tg-red" v-if="permintaan.status === 3">Ditolak</span>
                </div>
            </div>
        </template>
    </SOSlotCard>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

export default {
    name: "CardPermintaanKasOutlet",
    components: {
        SOSlotCard,
    },
    props: {
        permintaan: Object,
        search: {
            type: String,
            default: "",
        },
    },
    mounted() {
        this.fixCardUI();
    },
    methods: {
        fixCardUI() {
            setTimeout(() => {
                $(".card").addClass("permintaan-outlet-card-fix");
                $(".card-footer").addClass("permintaan-outlet-card-footer-fix");
            }, 200);
        },
    },
};
</script>

<style>
.need-confirm {
    padding: 4px 16px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.permintaan-outlet-card-footer-bg {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.permintaan-outlet-card-footer-fix {
    padding: 0 !important;
}

.permintaan-outlet-card-fix {
    padding-bottom: 0 !important;
}
</style>
